import React, { useRef, useState, useEffect } from 'react';
import CalendarioWidget from '../../compartedRoutes/Contabilidad/CalendarioWidget';
// import { serviciosApi } from '../../servicios/api'; // si tienes API real

const CalendarioAdmin = () => {
  const calRef = useRef(null);

  const [servicios, setServicios] = useState([]);

  // ⬇️ Estos son los que quieres “retornar” como props:
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFinal, setFechaFinal] = useState(null);

  // Carga inicial (demo). Sustituye por tu API si quieres.
  useEffect(() => {
    const hoy = new Date();
    const demo = [
      {
        codigo: 'S-1001',
        materia: 'Matemáticas I',
        cliente: 'Juan Pérez',
        nombreEmpresa: 'EduSmart',
        identificadorcodigo: 'P',
        fechaentrega: new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 10, 0, 0),
        entregasTrabajo: [{ id: 'Ent-01', fechaentrega: new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 8, 0, 0) }],
      },
      {
        codigo: 'S-1002',
        materia: 'Logística',
        cliente: 'María López',
        nombreEmpresa: 'EduSmart',
        identificadorcodigo: 'Q',
        fechaentrega: new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + 1, 14, 0, 0),
        entregasTrabajo: [],
        entregatutorFecha: '2024-01-01',
      },
    ];
    setServicios(demo);

    // Con API real filtrando por rango:
    // serviciosApi.list({ from: fechaInicioISO, to: fechaFinalISO }).then(setServicios);
  }, []);

  // Recibe del widget el rango visible y ACTUALIZA estado local
  const handleRangoChange = ({ fechaInicio, fechaFinal }) => {
    setFechaInicio(fechaInicio);
    setFechaFinal(fechaFinal);

    // (Opcional) Si quieres cargar por rango:
    // if (fechaInicio && fechaFinal) {
    //   serviciosApi.list({ from: fechaInicio.toISOString(), to: fechaFinal.toISOString() })
    //     .then(setServicios)
    //     .catch(console.error);
    // }
  };

  const leerRangoActual = () => {
    const r = calRef.current?.getRangoVisible?.();
    if (r) alert(`Rango actual:\n${r.fechaInicio}\n→ ${r.fechaFinal}\n(vista: ${r.vista})`);
  };

  return (
      <div className="mb-4 flex items-center justify-between">
        <div className="text-sm text-gray-700">
          <strong>Rango visible:</strong>{' '}
          {fechaInicio && fechaFinal
            ? `${new Date(fechaInicio).toLocaleDateString()} → ${new Date(fechaFinal).toLocaleDateString()}`
            : '—'}
        </div>

        <button
          onClick={leerRangoActual}
          className="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-700"
        >
          Leer rango por ref
        </button>
      </div>
    );
  
}

export default CalendarioAdmin;
